import { Separator } from "@/components/ui/separator";
import { AboutSection } from "./footer/AboutSection";
import { CategoriesSection } from "./footer/CategoriesSection";
import { SocialSection } from "./footer/SocialSection";
import { FooterBottom } from "./footer/FooterBottom";

export const Footer = () => {
  return (
    <footer className="bg-[#35009B]">
      <div className="container mx-auto py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <AboutSection />
          <CategoriesSection />
          <SocialSection />
        </div>
        
        <Separator className="my-8 bg-white/20" />
        
        <FooterBottom />
      </div>
    </footer>
  );
};